import * as Sentry from '@sentry/vue'
import Vue from 'vue'
import { v4 as uuidv4 } from 'uuid'

export function initSentry({ userID }) {
  Sentry.setUser({ id: userID })
  Sentry.setTag('page', 'digital-learning')
}

export default ({ app }, inject) => {
  const ENV = process.env.ENVIROMENT
  const isDev = ENV === 'development'

  let userID = app.$cookies.get('userID')
  if (!userID) {
    userID = uuidv4()
  }

  const domain = window.location.hostname

  const cookieOptions = {
    path: '/',
    maxAge: 60 * 60 * 24 * 365,
    sameSite: 'lax',
    domain: domain.includes('localhost') ? undefined : `.${domain}`,
  }

  app.$cookies.set('userID', userID, cookieOptions)

  Vue.config.errorHandler = (err, vm, info) => {
    Sentry.captureException(err)
  }

  if (!isDev) {
    initSentry({
      userID,
    })
  }
}
